import { render } from "./expertExperienceForm.vue?vue&type=template&id=3537068b&ts=true"
import script from "./expertExperienceForm.vue?vue&type=script&lang=ts"
export * from "./expertExperienceForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__